import Glide from '@glidejs/glide'

export default () => {
  return {
    slider: null,
    prevString: '<',
    nextString: '>',
    isVisibleClass: 'invisible z-0',
    visibleClasses: 'scale-0 opacity-0',
    options: {
      bound: true,
    },
    openLightbox(index = 0) {
      this.mountSlider(index - 1)
      this.isVisibleClass = 'z-40'
      setTimeout(() => {
        this.visibleClasses = 'scale-100 opacity-100'
      }, 500)
    },
    mountSlider(slide) {
      this.options.startAt = slide
      this.slider = new Glide(this.$refs.gallery, this.options)
      this.slider.mount()
      this.prevString = this.prevString ?? '<'
      this.nextString = this.nextString ?? '>'
      this.slider.on(['resize'], () => {
        this.slider.update()
      })
    },
    closeLightbox() {
      this.visibleClasses = 'scale-0 opacity-0'
      setTimeout(() => {
        this.isVisibleClass = 'invisible z-0'
      }, 500)
    },
  }
}
